import { QueryObserverResult } from '@tanstack/react-query';
import { apiStampUser } from 'src/apis/utils/stamp';
import {
  IStampPopup,
  IStampUserMissionInfo,
} from 'src/interfaces/user-mobile/stamp.interface';
import { FlexBox } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

interface IProps {
  uuid: string;
  popupInfo: IStampPopup;
  refetchUserMissionInfo: () => Promise<
    QueryObserverResult<IStampUserMissionInfo[], unknown>
  >;
}
export default function PreClearModal({
  uuid,
  popupInfo,
  refetchUserMissionInfo,
}: IProps) {
  const onClickModalButton = () => {
    apiStampUser
      .patchStampUser(uuid, popupInfo?.userMissionId)
      .then(() => refetchUserMissionInfo())
      .catch(error => alert(error));
  };

  return (
    <ModalWrapper>
      <ModalTextBox>
        <ModalTitle>{popupInfo?.title}</ModalTitle>
        <ModalSummary>{popupInfo?.summary}</ModalSummary>
      </ModalTextBox>
      <ModalButton onClick={onClickModalButton}>
        스탬프 1개 적립하기
      </ModalButton>
    </ModalWrapper>
  );
}

const ModalWrapper = styled(FlexBox)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 80%;
  flex-shrink: 0;

  padding: 16px;
  padding-top: 32px;

  border-radius: 16px;
  background: #fff;

  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalTextBox = styled(FlexBox)`
  margin-bottom: 24px;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const ModalTitle = styled.h1`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
`;

const ModalSummary = styled.p`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  white-space: pre-line;
`;

const ModalButton = styled.button`
  width: 100%;
  padding: 8px 0;

  border-radius: 6px;
  background: #7943e7;

  color: #fff;
  text-align: center;

  /* Button/BUT1_Sb */
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
`;
